import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import { connect } from "react-redux";
import Moment from "react-moment";
import { ToastContainer, toast } from "react-toastify";
import { paymentTransactionSettingActions } from "../../actions";
import tableRequest from "../../models/tableRequest.js";
import "./PaymentTransactionSetting.css";

class PaymentTransactionSetting extends Component {
  constructor(props) {
    super(props);
    this.tblResponse = new tableRequest();

    this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.CreatedDateTemplate = this.CreatedDateTemplate.bind(this);
    this.UpdatedDateTemplate = this.UpdatedDateTemplate.bind(this);
    this.UserAccountLockTemplate = this.UserAccountLockTemplate.bind(this);
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.exportCSV = this.exportCSV.bind(this);

    this.state = {
      IsAdd: true,
      IsEdit: true,
      first: 0,
      rows: 5,
      totalRecords: 0,
      globalFilter: null,
      sortOrder: "",
      buttonLabel: "Submit",
      formHeading: "Add Payment Transaction Setting",

      SettingId: 0,
      CreatedDate: null,
      UpdatedDate: null,

      PerDayTransactionAmount:0,
      RedemptionCount: 0,
      UserAccountLock:0,

      IsActive: true,

      formError: {
        PerDayTransactionAmount: "",
        RedemptionCount: "",
        UserAccountLock: "",
      },
    };
  }

  //to trigger api on page call
  componentDidMount() {
    const userDetails = sessionStorage.getItem("user");
    const userdetailsObject = JSON.parse(userDetails);
    this.setState({
      UserId: userdetailsObject.UserId,
    });

    const userPages = sessionStorage.getItem("assignedPermissionsForUser");
    if (userPages) {
      const assignedPermissions = JSON.parse(userPages);
      const Curenturl = window.location.pathname;
      const nNumber = Curenturl.lastIndexOf("/");
      const pageName = Curenturl.substring(nNumber + 1);
      const obj = assignedPermissions.assigned.filter((x) => {
        return x.ActionName === pageName;
      });

      if (obj !== null && obj.length > 0) {
        if (!obj[0].IsEdit) {
          this.setState({ IsEdit: false });
        }
        if (!obj[0].IsAdd) {
          this.setState({ IsAdd: false });
        }
      }
    }

    this.props.fetchApi(this.tblResponse);
  }

  componentDidUpdate(prevProps) {
    if (this.props.SettingData) {
      if (prevProps.SettingData !== this.props.SettingData) {
        var e = this.props.SettingData;
        this.setState({
          totalRecords: e[0].TotalRows,
        });
      }
    } else {
      if (this.state.totalRecords !== 0)
        this.setState({
          totalRecords: 0,
          first: 0,
        });
    }
  }

  //to lazy load
  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows, first: event.first });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }

  onPage(event) {
    this.props.loadingData(true);
    this.getLazyLoadingValues(event);
    this.props.fetchApi(this.tblResponse);
  }

  //to search
  searchFilter(e) {
    this.props.loadingData(true);
    this.tblResponse.SearchValue = e.target.value;
    this.props.fetchApi(this.tblResponse);
  }

  //to sort
  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC";
    this.props.fetchApi(this.tblResponse);
  }

  //to handle form
  handleChange(event) {
    let { name, value } = event.target;
    const numericFields = [
      "PerDayTransactionAmount",
      "RedemptionCount",
      "UserAccountLock",
    ];
    if (numericFields.includes(name)) {
      value = value.replace(/[^0-9]/g, "");
    }
    value = value === "" ? "" : Number(value);
    let errors = this.state.formError;
    this.validateForm(value, name);
    this.setState({ errors, [name]: value });
  }

  //to validate form data
  validateForm(value, name) {
    let errors = this.state.formError;
    let IsValid = true;

    switch (name) {
      case "PerDayTransactionAmount":
        if (!value && value !== 0) {
          IsValid = false;
          errors.PerDayTransactionAmount =
            "Please enter Per Day Transaction Amount.";
        } else if (!/^[0-9]+$/.test(value)) {
          IsValid = false;
          errors.PerDayTransactionAmount = "Please enter a valid amount.";
        } else if (parseInt(value, 10) <= 0) {
          IsValid = false;
          errors.PerDayTransactionAmount = "Amount must be greater than 0.";
        } else if (parseInt(value, 10) > 10000000) {
          IsValid = false;
          errors.PerDayTransactionAmount = "Amount cannot exceed 1 crore.";
        } else {
          errors.PerDayTransactionAmount = null;
        }
        break;

      case "RedemptionCount":
        if (!value && value !== 0) {
          IsValid = false;
          errors.RedemptionCount = "Please enter Redemption Count.";
        } else if (!/^[0-9]+$/.test(value)) {
          IsValid = false;
          errors.RedemptionCount = "Please enter only numbers.";
        } else if (parseInt(value, 10) <= 0) {
          IsValid = false;
          errors.RedemptionCount = "Redemption Count must be at least 1.";
        } else if (parseInt(value, 10) > 10000) {
          IsValid = false;
          errors.RedemptionCount = "Redemption Count cannot exceed 10000.";
        } else {
          errors.RedemptionCount = null;
        }
        break;

      case "UserAccountLock":
        if (!value && value !== 0) {
          IsValid = false;
          errors.UserAccountLock =
            "Please enter User Account Lock attempt count.";
        } else if (!/^[0-9]+$/.test(value)) {
          IsValid = false;
          errors.UserAccountLock = "Please enter only numbers.";
        } else if (parseInt(value, 10) <= 0) {
          IsValid = false;
          errors.UserAccountLock = "Value must be at least 1.";
        } else if (parseInt(value, 10) > 10000) {
          IsValid = false;
          errors.UserAccountLock = "Value cannot exceed 10000.";
        } else {
          errors.UserAccountLock = null;
        }
        break;

      default:
        break;
    }

    this.setState({ formError: errors });
    return IsValid;
  }

  //to get current date
  getCurrentDateMMDDYYY() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();

    today = mm + "/" + dd + "/" + yyyy;
    return today;
  }

  submitForm(event) {
    event.preventDefault();
    let isfrmvalid = true;
    let checkerror = this.state.formError;

    Object.entries(checkerror).map(([key, value]) => {
      const val = this.state[key];
      let valid = this.validateForm(val, key);
      if (!valid) {
        isfrmvalid = false;
      }
      return isfrmvalid;
    });

    if (isfrmvalid) {
      const formData = {
        SettingId: 1,
        PerDayTransactionAmount: parseInt(this.state.PerDayTransactionAmount, 10),
        RedemptionCount: parseInt(this.state.RedemptionCount, 10),
        UserAccountLock: parseInt(this.state.UserAccountLock, 10),
        CreatedDate:
          this.state.SettingId > 0
            ? this.state.CreatedDate
            : this.getCurrentDateMMDDYYY(),
        UpdatedDate:
          this.state.SettingId > 0 ? this.getCurrentDateMMDDYYY() : null,
        TotalRows: this.state.totalRecords,
      };

      const request =
        this.state.SettingId === 0
          ? this.props.createSetting(formData)
          : this.props.updateSetting(formData);

      Promise.resolve(request)
        .then(() => {
          this.resetForm();
          this.props.fetchApi(this.tblResponse);
        })
        .catch(() => {});
    }
  }

  //to reset form back to add mode
  resetForm() {
    this.setState({
      SettingId: 0,
      buttonLabel: "Submit",
      formHeading: "Add Payment Transaction Setting",
      PerDayTransactionAmount: 0,
      RedemptionCount: 0,
      UserAccountLock: 0,
      formError: {
        PerDayTransactionAmount: "",
        RedemptionCount: "",
        UserAccountLock: "",
      },
    });
  }

  //to get format of date
  UpdatedDateTemplate(rowData) {
    if (rowData && rowData.UpdatedDate !== null) {
      return <Moment format="D MMM YYYY">{rowData.UpdatedDate}</Moment>;
    }
  }

  //to get format of date
  CreatedDateTemplate(rowData) {
    if (rowData && rowData.CreatedDate !== null) {
      return <Moment format="D MMM YYYY">{rowData.CreatedDate}</Moment>;
    }
  }

  //to display user account lock attempts with a lock icon
  UserAccountLockTemplate(rowData) {
    return (
      <span>
        <i className="pi pi-lock mr-2"></i>
        {rowData ? rowData.UserAccountLock : ""}
      </span>
    );
  }

  //to edit rowdata
  actionBodyTemplate(rowData) {
    const editMode = () => {
      this.setState({
        buttonLabel: "Update",
        formHeading: "Update Payment Transaction Setting",
        SettingId: rowData.SettingId,
        PerDayTransactionAmount: rowData.PerDayTransactionAmount,
        RedemptionCount: rowData.RedemptionCount,
        UserAccountLock: rowData.UserAccountLock,
        CreatedDate: rowData.CreatedDate,
      });
    };
    return <Button icon="pi pi-pencil" onClick={editMode} />;
  }

  //to export data
  exportCSV() {
    this.dt.exportCSV();
  }

  //to render html
  render() {
    const header = (
      <div className="ptx-toolbar row my-3">
        <div className="col-md-5 mb">
          <h4>Payment Transaction Setting</h4>
        </div>

        <div className="col-md-7 search layoutright">
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onInput={(e) => this.searchFilter(e)}
              placeholder="Global Search"
            />
          </span>
        </div>
      </div>
    );

    return (
      <div className="datatable-filter-demo ptx-page">
        <ToastContainer />

        {this.state.IsAdd === true ? (
          <div className="card ptx-form-card mb-3">
            <h4 className="ptx-card-title">{this.state.formHeading}</h4>
            <div className="row">
              <div className="col-md-6 pt-2">
                <TextField
                  onChange={this.handleChange}
                  value={this.state.PerDayTransactionAmount}
                  name="PerDayTransactionAmount"
                  type="text"
                  inputMode="numeric"
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="Per Day Transaction Amount*"
                />
                {this.state.formError.PerDayTransactionAmount !== "" ? (
                  <div className="error">
                    {this.state.formError.PerDayTransactionAmount}
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div className="col-md-6 pt-2">
                <TextField
                  onChange={this.handleChange}
                  value={this.state.RedemptionCount}
                  name="RedemptionCount"
                  type="text"
                  inputMode="numeric"
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="Redemption Count*"
                />
                {this.state.formError.RedemptionCount !== "" ? (
                  <div className="error">
                    {this.state.formError.RedemptionCount}
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div className="col-md-6 pt-3">
                <TextField
                  onChange={this.handleChange}
                  value={this.state.UserAccountLock}
                  name="UserAccountLock"
                  type="text"
                  inputMode="numeric"
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="User Account Lock (Attempts)*"
                />
                {this.state.formError.UserAccountLock !== "" ? (
                  <div className="error">
                    {this.state.formError.UserAccountLock}
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div className="col-md-6 pt-3 ptx-form-actions">
                <Button
                  label={this.state.buttonLabel}
                  onClick={this.submitForm}
                  icon="pi pi-check"
                />
                {this.state.SettingId > 0 ? (
                  <Button
                    className="ml-2 p-button-secondary"
                    label="Cancel"
                    icon="pi pi-times"
                    onClick={this.resetForm}
                  />
                ) : (
                  ""
                )}
              </div>

              <div className="col-md-12 ptx-form-note">
                Note: Fields marked as (*) are required
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="card ptx-table-card">
          <DataTable
            value={this.props.SettingData}
            scrollable
            responsive={true}
            globalFilter={this.state.globalFilter}
            header={header}
            emptyMessage="No data found."
            sortMode="multiple"
            paginator={true}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={this.state.rows}
            style={{ width: "100%" }}
            rowsPerPageOptions={[5, 10, 20, parseInt(this.state.totalRecords)]}
            totalRecords={parseInt(this.state.totalRecords)}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
            loading={this.props.loading}
            ref={(el) => {
              this.dt = el;
            }}
          >
            <Column
              field="PerDayTransactionAmount"
              header="Per Day Transaction Amount"
              sortable
            ></Column>
            <Column
              field="RedemptionCount"
              header="Redemption Count"
              sortable
            ></Column>
            
            <Column
              field="UserAccountLock"
              header="User Account Lock"
              body={this.UserAccountLockTemplate}
              sortable
            ></Column>
            <Column
              field="CreatedDate"
              header="Created Date"
              body={this.CreatedDateTemplate}
              sortable
            ></Column>
            <Column
              field="UpdatedDate"
              header="Updated Date"
              body={this.UpdatedDateTemplate}
              sortable
            ></Column>
            {this.state.IsEdit === true ? (
              <Column header="Action" body={this.actionBodyTemplate}></Column>
            ) : null}
          </DataTable>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    SettingData: state.paymentTransactionSetting.items,
    loading: state.company.loding,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => {
      dispatch(paymentTransactionSettingActions.getAll(obj));
    },
    createSetting: (data) =>
      dispatch(paymentTransactionSettingActions.createSetting(data)),
    updateSetting: (data) =>
      dispatch(paymentTransactionSettingActions.updateSetting(data)),
    loadingData: (isLoding) =>
      dispatch(paymentTransactionSettingActions.loadingData(isLoding)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentTransactionSetting);